import React from 'react';
import ReactDOM from 'react-dom';
import { Font, Image, PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import _, { slice } from 'lodash';
import { Avatar, Button, colors, Divider, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';

import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon,
} from 'react-share';

import {
  EmailShareButton,
  FacebookShareButton,
  HatenaShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from 'react-share';
import useQuery from '../../hooks/useQuery';
import Cookies from 'universal-cookie';
import { fetchWith401Check } from '../../helpers/http';

const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

Font.register({
  family: 'Montserrat',
  fonts: [
    { src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew-Y3tcoqK5.ttf' },
    { src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM70w-Y3tcoqK5.ttf', fontWeight: 300 },
    { src: 'http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq_p9aX9-p7K5ILg.ttf', fontStyle: 'italic' },
  ],
});

// Create styles
const styles = StyleSheet.create({
  page: {
    margin: 20,
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  sectionRowSpacingBetween: {
    flexDirection: 'row',
    padding: 10,
    justifyContent: 'space-between',
  },
  sectionColumn: {
    flexDirection: 'column',
    padding: 10,
    marginRight: 10,
  },
  fontTitle: {
    fontSize: 18,
    marginRight: 16,
    fontFamily: 'Montserrat',
    fontWeight: 300,
    textAlign: 'center',
    color: colors.red[400],
  },
  fontSectionTitle: {
    fontSize: 12,
    marginBottom: 6,
    fontFamily: 'Montserrat',
    fontWeight: 300,
  },
  fontText: {
    fontSize: 12,
    marginBottom: 6,
    fontFamily: 'Montserrat',
    wordBreak: 'break-word',
  },
});

// Create Document Component
function htmlToPdf(html) {
  const components = [];

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  function parseNode(node) {
    if (node.nodeType === 3) {
      components.push(<Text style={{ ...styles.fontText }}>{node.textContent}</Text>);
    } else if (node.nodeName === 'IMG') {
      components.push(<Image src={node.src} />);
    } else {
      const children = Array.from(node.childNodes || []);
      components.push(<View>{children.map((child) => parseNode(child))}</View>);
    }
  }

  parseNode(doc.body);

  return components;
}
const TheDocument = ({ data, metadata }) => (
  <Document>
    <Page size='FOLIO' wrap style={styles.page}>
      <View style={styles.sectionColumn}>
        <Text style={styles.fontTitle}>{data.title}</Text>
      </View>
      {/* <View style={styles.sectionRowSpacingBetween}>
        <View style={{ flex: 1, padding: 4 }}>
          <Image allowDangerousPaths src={data.thumbnail[0]} />
        </View>
        <View style={{ flex: 1, padding: 4 }}>
          <Text style={{ ...styles.fontText }}>Type: {data.jenis}</Text>
          <Text style={{ ...styles.fontText }}>Year of publication: {data.tahun}</Text>
          <Text style={{ ...styles.fontText }}>SDGs: </Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            {data?.sdg_goal.map((item, index) => (
              <Image key={index} style={{ width: 60, margin: 4 }} src={`/repository/assets/sdg_goal_${item.split('_')[1]}.jpeg`} />
            ))}
          </View>
        </View>
      </View> */}
      <View style={styles.sectionColumn}>
        {/* <View style={styles.sectionColumn}>
          <Text style={styles.fontSectionTitle}>Entity</Text>
          <View style={styles.sectionColumn}>
            {data?.institution_agency?.map((item, index) => (
              <Text style={styles.fontText} key={index}>
                [{index + 1}] {item?.agency?.label || item?.agency?.other[0]}
              </Text>
            ))}
          </View>
        </View> */}
        <View style={styles.sectionColumn} wordBreak>
          {/* <Text style={styles.fontSectionTitle}>Summary</Text> */}
          <View style={styles.sectionColumn}>
            <Text style={{ ...styles.fontText }}>{data?.ringkasan ? data?.ringkasan?.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, '') : '-'}</Text>
            {/* {htmlToPdf(data?.ringkasan)} */}
          </View>
        </View>
        <View style={styles.sectionColumn} break>
          {data?.attachments?.map((item, index) => (
            <View style={styles.sectionColumn} break={index % 2 === 0}>
              {index === 0 && <Text style={styles.fontSectionTitle}>Attachments</Text>}
              <Text style={styles.fontText}>
                [{index + 1}] {item.path}
              </Text>
              <Text style={styles.fontText}>{item.description}</Text>
              {['png', 'jpg', 'jpeg'].includes(item.path.split('.')[item.path.split('.').length - 1]) && <Image src={item.path} style={{ width: 400 }} />}
            </View>
          ))}
        </View>
        {/* <View style={styles.sectionColumn} break>
          <Text style={styles.fontSectionTitle}>Sectors</Text>
          <View style={styles.sectionColumn}>
            {data?.sector?.map((item, index) => (
              <Text style={styles.fontText} key={index}>
                [{index + 1}] {metadata?.sectors[item]?.label}
              </Text>
            ))}
          </View>
        </View> */}
      </View>
    </Page>
  </Document>
);

const TheDocumentWithPhoto = ({ data, metadata }) => (
  <Document>
    <Page size='FOLIO' wrap style={styles.page}>
      <View style={styles.sectionColumn}>
        <Text style={styles.fontTitle}>{data.title}</Text>
      </View>
      <View style={styles.sectionRowSpacingBetween}>
        <View style={{ flex: 1, padding: 4 }}>
          {/* <Image allowDangerousPaths src={data.thumbnail[0]} /> */}
          <Image allowDangerousPaths src={'/repository/assets/bappenas_logo_square.png'} />
        </View>
        {/* <View style={{ flex: 1, padding: 4 }}>
          <Text style={{ ...styles.fontText }}>Type: {data.jenis}</Text>
          <Text style={{ ...styles.fontText }}>Year of publication: {data.tahun}</Text>
          <Text style={{ ...styles.fontText }}>SDGs: </Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            {data?.sdg_goal.map((item, index) => (
              <Image key={index} style={{ width: 60, margin: 4 }} src={`/repository/assets/sdg_goal_${item.split('_')[1]}.jpeg`} />
            ))}
          </View>
        </View> */}
      </View>
      <View style={styles.sectionColumn}>
        {/* <View style={styles.sectionColumn}>
          <Text style={styles.fontSectionTitle}>Entity</Text>
          <View style={styles.sectionColumn}>
            {data?.institution_agency?.map((item, index) => (
              <Text style={styles.fontText} key={index}>
                [{index + 1}] {item?.agency?.label || item?.agency?.other[0]}
              </Text>
            ))}
          </View>
        </View> */}
        <View style={styles.sectionColumn}>
          {/* <Text style={styles.fontSectionTitle}>Summary</Text> */}
          <View style={styles.sectionColumn}>
            <Text style={{ ...styles.fontText }}>{data?.ringkasan ? data?.ringkasan?.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, '') : '-'}</Text>
            {/* {htmlToPdf(data?.ringkasan)} */}
          </View>
        </View>
        <View style={styles.sectionColumn} break>
          {data?.attachments?.map((item, index) => (
            <View style={styles.sectionColumn} break={index % 2 === 0}>
              {index === 0 && <Text style={styles.fontSectionTitle}>Attachments</Text>}
              <Text style={styles.fontText}>
                [{index + 1}] {item.path}
              </Text>
              <Text style={styles.fontText}>{item.description}</Text>
              {['png', 'jpg', 'jpeg'].includes(item.path.split('.')[item.path.split('.').length - 1]) && <Image src={item.path} style={{ width: 400 }} />}
            </View>
          ))}
        </View>
        {/* <View style={styles.sectionColumn} break>
          <Text style={styles.fontSectionTitle}>Sectors</Text>
          <View style={styles.sectionColumn}>
            {data?.sector?.map((item, index) => (
              <Text style={styles.fontText} key={index}>
                [{index + 1}] {metadata?.sectors[item]?.label}
              </Text>
            ))}
          </View>
        </View> */}
      </View>
    </Page>
  </Document>
);

const DocumentPDF = ({ userInfo }) => {
  const params = useParams();
  const query = useQuery();
  const isReview = query.get('is_review');
  const isShare = query.get('share');
  const documentTitle = query.get('title');

  const [repository, setRepository] = React.useState({});
  const [sectors, setSectors] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [downloadProps, setDownloadProps] = React.useState({ name: '', purpose: '' });
  const [comment, setComment] = React.useState('');
  const [comments, setComments] = React.useState([]);
  const [docStatus, setDocStatus] = React.useState();
  const cookies = new Cookies();

  const fetchRepositoryByID = async () => {
    if (!params.id) return;
    if (!_.isEmpty(repository)) return;

    fetchWith401Check(`${API_URL}/tabledatas/summary/id?id=${params.id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const repoData = response?.response || {};
        setRepository({ ...repository, ...repoData });
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  const fetchSectors = async () => {
    if (!params.id) return;

    fetchWith401Check(`${API_URL}/tableprops/sectors`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const sectorsData = response?.responses || {};
        let _sectors = {};
        sectorsData.forEach((item) => {
          _sectors[item.key] = { label: item.label, label_id: item.label_id };
        });
        setSectors({ ...sectors, ..._sectors });
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  const countDownload = async () => {
    if (!params.id) return;

    fetchWith401Check(`${API_URL}/tabledatas/count-download?id=${params.id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
      body: JSON.stringify({ ...downloadProps }),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const data = response?.responses || {};
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  React.useEffect(() => {
    if (params?.id) fetchRepositoryByID();
  }, [params]);

  React.useEffect(() => {
    fetchSectors();
  }, []);

  React.useEffect(() => {}, [repository.id]);

  return (
    <>
      {!_.isEmpty(repository.data) ? (
        <Stack direction='column' alignItems='center' spacing={2} p={2} sx={{ width: '100%' }}>
          {!isShare && !isReview && (
            <Stack direction='column' alignItems='center' spacing={2}>
              <Stack direction='row' spacing={2}>
                <TextField
                  value={downloadProps.name}
                  onChange={(e) => setDownloadProps({ ...downloadProps, name: e.currentTarget.value })}
                  sx={{ width: 300 }}
                  label='Downloader name'
                  placeholder='Enter your name/institution name'
                />
                <TextField
                  value={downloadProps.purpose}
                  onChange={(e) => setDownloadProps({ ...downloadProps, purpose: e.currentTarget.value })}
                  sx={{ width: 500 }}
                  label='Download Purpose'
                  placeholder='Your purpose of downloading this document'
                />
              </Stack>

              {downloadProps.name && downloadProps.purpose ? (
                <PDFDownloadLink
                  document={
                    repository.data.thumbnail[0] ? (
                      <TheDocumentWithPhoto data={repository.data} metadata={{ sectors }} />
                    ) : (
                      <TheDocument data={repository.data} metadata={{ sectors }} />
                    )
                  }
                  fileName={`${params.id}.pdf`}
                >
                  {({ blob, url, loading, error }) =>
                    loading ? (
                      'Loading document...'
                    ) : (
                      <Button
                        variant='contained'
                        onClick={countDownload}
                        disabled={!downloadProps.name || !downloadProps.purpose}
                        style={{ textDecoration: 'none' }}
                      >
                        Download PDF
                      </Button>
                    )
                  }
                </PDFDownloadLink>
              ) : (
                <Button variant='contained' onClick={countDownload} disabled={!downloadProps.name || !downloadProps.purpose} style={{ textDecoration: 'none' }}>
                  Download PDF
                </Button>
              )}
            </Stack>
          )}
          {isShare && (
            <Stack direction='column' spacing={1} p={4} alignItems='center'>
              <Typography sx={{ textAlign: 'center' }} variant='h5'>
                Share
              </Typography>
              <Stack direction='row' spacing={1}>
                <FacebookShareButton url={window.location.href} quote={documentTitle} separator='-'>
                  <FacebookIcon size={64} round />
                </FacebookShareButton>
                <EmailShareButton url={window.location.href} body={documentTitle} subject={documentTitle} separator='-'>
                  <EmailIcon size={64} round />
                </EmailShareButton>
                <TwitterShareButton title={documentTitle} url={window.location.href} separator='-'>
                  <TwitterIcon size={64} round />
                </TwitterShareButton>
                <WhatsappShareButton title={documentTitle} url={window.location.href} separator='-'>
                  <WhatsappIcon size={64} round />
                </WhatsappShareButton>
              </Stack>
            </Stack>
          )}
          <Stack direction='row' sx={{ width: '70vw' }} p={4}>
            <Stack sx={{ flex: 3 }}>
              <PDFViewer showToolbar={false} width='100%' height='800'>
                {repository.data.thumbnail[0] ? (
                  <TheDocumentWithPhoto data={repository.data} metadata={{ sectors }} />
                ) : (
                  <TheDocument data={repository.data} metadata={{ sectors }} />
                )}
              </PDFViewer>
            </Stack>

            {/* <Stack direction='column' sx={{ flex: 1, maxHeight: '100vh', overflow: 'scroll' }} pl={2} pr={2} spacing={2} alignItems='flex-start'>
              <Typography>Comments</Typography>
              <TextField
                value={comment}
                onChange={(e) => setComment(e.currentTarget.value)}
                fullWidth
                multiline
                id='outlined-basic'
                label='Insert your comment here'
                variant='outlined'
              />
              <Button onClick={addComment}>Add comment</Button>
              <Divider sx={{ width: '100%' }} />
              {_.isEmpty(comments) && <Typography>No comments found</Typography>}
              {!_.isEmpty(comments) && (
                <Stack direction='column' alignItems='flex-start' spacing={2}>
                  {comments.map((item, index) => (
                    <Stack key={index} direction='column' alignItems='flex-start' spacing={2}>
                      <Stack direction='row' spacing={2}>
                        <Avatar sx={{ bgcolor: generateRandomColor(item?.created_by?.slice(0, 2).toUpperCase()) }}>
                          {item?.created_by?.slice(0, 2).toUpperCase()}
                        </Avatar>
                        <Stack direction='column'>
                          <Typography variant='caption'>{item?.createdAt}</Typography>
                          <Typography variant='caption'>{item?.created_by}</Typography>
                          <Typography variant='body2'>{item?.content?.text}</Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  ))}
                </Stack>
              )}
            </Stack> */}
          </Stack>
        </Stack>
      ) : (
        <>
          <Typography variant='body2'>Loading ...</Typography>
        </>
      )}
    </>
  );
};

// ReactDOM.render(<DocumentPDF />, document.getElementById('root'));
export default DocumentPDF;
